// Shared banner enums — used across multiple entity const files.

export const BANNER_REGULATION = {
  GDPR: 'gdpr',
  CCPA: 'ccpa',
  LGPD: 'lgpd',
  PIPEDA: 'pipeda',
  NOTICE: 'notice',
}

export const SCAN_STATUS = {
  PENDING: 'pending',
  SCANNING: 'scanning',
  COMPLETED: 'completed',
  FAILED: 'failed', // FE-only fallback for any non-pending/non-scanning/non-completed terminal status
}

export const SCAN_TYPE = {
  PREVIEW: 'preview',
  FULL: 'full',
}

export const SITE_SCAN_PHASE = {
  NEVER_SCANNED: 'never_scanned',
  PREVIEW_DONE_FULL_RUNNING: 'preview_done_full_running',
  FULL_COMPLETE: 'full_complete',
}

/** BE category values for scan result trackers (Cookies & Trackers tab category dropdown). */
export const TRACKER_CATEGORIES = {
  ANALYTICS: 'analytics',
  MARKETING: 'marketing',
  PREFERENCES: 'preferences',
  NECESSARY: 'necessary',
}

export const TRACKER_CLASSIFICATION_STATUS = {
  CLASSIFIED: 'classified',
  UNCLASSIFIED: 'unclassified',
}
